import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid } from 'semantic-ui-react';
// @ts-ignore
import FieldValue from 'components/FieldValue';
import { makeSelectSprayEventMultipleOperatorsTabActiveIndex } from 'services/sprayEventMultipleOperatorsTab/selectors';
import { setSprayEventMultipleOperatorsTabIndex } from 'services/sprayEventMultipleOperatorsTab/actions';
import { isMultiOperatorApplicationType } from 'services/sprayEvents/utils';
import MultipleApplicatorsTab from '../MultipleOperatorsTab';
import { OperatorFieldNames } from '../MultipleOperatorsTab/constants';
import OperatorsEquipmentSet from './components/OperatorsEquipmentSet';

interface Props {
    lastSubmittedAt?: Date;
}

export default function EquipmentPage(props: Props): React.ReactElement {
    const { lastSubmittedAt } = props;
    const dispatch = useDispatch();

    const tabActiveIndex = useSelector(
        makeSelectSprayEventMultipleOperatorsTabActiveIndex()
    );

    React.useEffect(() => {
        return () => {
            dispatch(setSprayEventMultipleOperatorsTabIndex(0));
        };
    });

    return (
        <Grid className="spray-event-modal-step">
            <Grid.Row>
                <Grid.Column width="8">
                    <h4>Equipment details</h4>
                </Grid.Column>
            </Grid.Row>
            <FieldValue name="applicationType">
                {(applicationType: string): React.ReactElement => {
                    if (isMultiOperatorApplicationType(applicationType)) {
                        return (
                            <MultipleApplicatorsTab
                                tabActiveIndex={tabActiveIndex}
                                lastSubmittedAt={lastSubmittedAt}
                                childForOutsideRowTab={
                                    <OperatorsEquipmentSet
                                        name={OperatorFieldNames.OUTSIDE}
                                    />
                                }
                                childForDoubleRowTab={
                                    <OperatorsEquipmentSet
                                        name={OperatorFieldNames.DOUBLE}
                                    />
                                }
                            />
                        );
                    }

                    return (
                        <OperatorsEquipmentSet
                            name={OperatorFieldNames.STANDARD}
                        />
                    );
                }}
            </FieldValue>
        </Grid>
    );
}
